/**
 * London Smoke & Cure — facility live snapshot (Cloud Run cache; wall poll).
 */

import { njordApiFetch } from './njordApiClient';

/**
 * Shallow live rows for all active sensors (from presence-sweep cache when fresh).
 * @param {{ maxAgeMs?: number }} [opts]
 * @returns {Promise<{ at: number, ageMs: number, live: Record<string, object>, sensorCount: number }>}
 */
export async function fetchNjordFacilityLive(opts = {}) {
    const maxAgeMs = Number(opts.maxAgeMs) || 90_000;
    const q = new URLSearchParams({ maxAgeMs: String(maxAgeMs) });
    return njordApiFetch(`/api/facility/live?${q}`);
}
